var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { injectIntl } from "@s7ui-kit/s7ui-kit";
import { useLocation } from "react-router-dom";
import { TabNavigationWidget } from "@s7/navigation";
import { getItems, LITE_PATH } from "../constants";
import { NavigationStep } from "../types";
import { analytics } from "../../../../services/analytics/analyticsManager";
import { useMediaQuery } from "@s7/styles";
import { getProfileLinkByAuthState } from "../../../shared/lib/getProfileLinkByAuthState";
import { Self } from "../../../shared/self";
var desktopHiddenSX = function (theme) {
    var _a;
    return (_a = {},
        _a[theme.fn.up("sm1")] = {
            display: "none",
        },
        _a);
};
export var TabNavigation = injectIntl(function (_a) {
    var words = _a.words, getMessage = _a.getMessage;
    var pathname = useLocation().pathname;
    var authorized = Self.useSelf().authorized;
    var isDesktop = useMediaQuery("sm1.up", {
        ssr: false,
        fallback: true,
    })[0];
    var activeTab = pathname.includes(LITE_PATH)
        ? NavigationStep.SEARCH
        : NavigationStep.PAGE;
    var profileHref = getProfileLinkByAuthState(void 0, authorized);
    var items = getItems(profileHref);
    var tabs = items.map(function (tab) { return (__assign(__assign({}, tab), { title: getMessage(words, tab.title) })); });
    if (isDesktop) {
        return null;
    }
    return (React.createElement(TabNavigationWidget, { analytics: analytics, data: tabs, value: activeTab, sx: desktopHiddenSX }));
});
